import { UserDateAudit } from 'src/app/core/model/user-date-audit';

export class ComponentModel extends UserDateAudit{
    id;
	code;
	name;
}